import React, { useState } from 'react'
import CheckoutSection from './CheckoutSection'
import { Button, Checkbox } from '@material-tailwind/react'
import { env } from './env'
import { isValidPhoneNumber } from 'react-phone-number-input'
import PhoneInput from 'react-phone-number-input'
import { countries } from './countries'
import { nationalities } from './nationalities'
import 'react-phone-number-input/style.css'
import DateOfBirthPicker from './components/DateOfBirthPicker'

function splitAndCapitalize (str) {
  // Split on _
  let parts = str.split('_')

  // Split further on capital letters and capitalize first letter
  parts = parts.map(part => {
    return part.split(/(?=[A-Z])/)  // Split on capital letters
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
      .join(' ')  // Join the split words with space
  })

  // Join the main parts with space and return
  return parts.join(' ')
}

function isEighteenOrOlder(birthdayStr) {
  // Convert the string to a Date object
  try {
    const parts = birthdayStr.split('/');
    const birthday = new Date(+parts[2], +parts[0] - 1, +parts[1]); // Note: The month is 0-indexed

    // Calculate the date that was 18 years ago from today
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

    // If the birthday is on or before the date 18 years ago, the person is 18 or older
    return birthday <= eighteenYearsAgo;
  } catch(e) {
    return false;
  }
}

// hacky stuff to format the list sent over by NuCo
function formatNationality (country) {
  let formattedCountry = country

  if (!country.includes('land') && !country.includes('rwanda') && !country.includes('uganda')) {
    formattedCountry = country.replace(/and/g, ' and ').replace(/of/g, ' of ').replace(/republic/g, ' republic ')
  } else {
    formattedCountry = country.replace(/island/g, ' island').replace(/of/g, ' of ').replace(/republic/g, ' republic ')
  }

  let capitalized = formattedCountry.split(' ').map(word => {
    if (word === 'and') {
      return word
    }

    if (word === 'of') {
      return word
    }
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join(' ')

  if (capitalized == 'Usa') { capitalized = 'USA' }
  if (capitalized == 'Uk') { capitalized = 'UK' }
  if (capitalized == ' and Orra') { capitalized = 'Andorra' }
  if (capitalized == 'Britishvirginislands') { capitalized = 'British Virgin Islands' }
  if (capitalized == 'Centralafrican Republic') { capitalized = 'Central African Republic' }
  if (capitalized == 'Equatorialguinea') { capitalized = 'Equatorial Guinea' }
  if (capitalized == 'Papuanewguinea') { capitalized = 'Papua New Guinea' }
  if (capitalized == 'Guineabisseau') { capitalized = 'Guinea Bisseau' }
  if (capitalized == 'Hongkong') { capitalized = 'Hong Kong' }
  if (capitalized == 'Ivorycoast') { capitalized = 'Ivory Coast' }
  if (capitalized == 'Newzealand') { capitalized = 'New Zealand' }
  if (capitalized == 'Northerncyprus') { capitalized = 'Northern Cyprus' }
  if (capitalized == 'Northkorea') { capitalized = 'North Korea' }

  return capitalized
}

export const CustomerInfoSection = ({setClientSecret, trip, formLoading}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    addressLine2: '',
    country: '',
    dob: '',
    city: '',
    state: '',
    gender: '',
    nationality: '',
    postalZip: '',
    phone: '',
    instagramHandle: '',
    billing_firstName: '',
    billing_lastName: '',
    billing_address: '',
    billing_addressLine2: '',
    billing_country: '',
    billing_city: '',
    billing_state: '',
    billing_postalZip: '',
  })

  const [stripeSaving, setStripeSaving] = useState(false)
  const [stripeSecret, setStripeSecret] = useState(false)
  const [customerSaving, setCustomerSaving] = useState(false)
  const [billingNotSame, setBillingNotSame] = useState(false)
  const [showForm, setShowForm] = useState(true)

  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const {name, value} = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors({...errors, [name]: ''})
  }

  const handlePhoneChange = (number) => {
    setFormData(prevState => ({
      ...prevState,
      phone: number,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setCustomerSaving(true)

    const validationErrors = {}
    setErrors({})

    for (const field in formData) {
      if(field === 'dob') {
        if(!isEighteenOrOlder(formData[field])) {
          validationErrors[field] = 'You must be 18 or older to book a trip'
        }
      }
      // Check if the field is empty and is not 'addressLine2'
      if (formData[field] === '' && field !== 'addressLine2' && field !== 'billing_addressLine2' && field !==
        'instagramHandle') {
        // If the field has a 'billing' prefix and billingNotSame is true
        if (field.startsWith('billing_') && billingNotSame) {
          validationErrors[field] = `${splitAndCapitalize(field)} is required`
        }

        // If the field does not have a 'billing' prefix
        if (!field.startsWith('billing_')) {
          validationErrors[field] = `${splitAndCapitalize(field)} is required`
        }
      }

      if (field === 'phone') {
        if (formData.phone === '') {
          validationErrors[field] = 'Invalid phone number'
        } else if (!isValidPhoneNumber(formData.phone)) {
          validationErrors[field] = 'Invalid phone number'
        }

      }

    }

    setErrors(validationErrors)

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await fetch(`${env.baseUrl}/payments/create-customer`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })

        if (!response.ok) {
          throw new Error('Network response was not ok')
        }

        const result = await response.json()

        // Save returned data to local storage
        localStorage.setItem('stripeKey', result.ephemeralKey)
        localStorage.setItem('stripeCustomerId', result.stripeCustomerId)
        localStorage.setItem('addressId', result.addressId)
        localStorage.setItem('userId', result.userId)
        setStripeSecret(result.ephemeralKey)
        setClientSecret(result.ephemeralKey)
        setShowForm(false)

        console.log('Data saved to local storage:', result)

      } catch (error) {
        console.error('There was an error with the fetch operation:', error)
      }
    }
    setCustomerSaving(false)
  }

  return (
    <section className="py-6 px-4 bg-white shadow-2xl p-4" style={{borderRadius: 20, margin: 20}}>

      {stripeSecret && !showForm
        ? <CheckoutSection formloading={formLoading} trip={trip} formData={formData} billingDifferent={billingNotSame}
                           editPassengerFn={() => setShowForm(true)}/>
        : <></>
      }

      {showForm ? (
        <>
          <h2 className="text-2xl font-bold text-center mb-8">Passenger Registration</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="firstName"
              placeholder="First Name* (as listed on passport)"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.firstName}
            />
            {errors.firstName && <p className="text-red-500 error-text">{errors.firstName}</p>}

            <input
              type="text"
              name="lastName"
              placeholder="Last Name* (as listed on passport)"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.lastName}
            />
            {errors.lastName && <p className="text-red-500 error-text">{errors.lastName}</p>}

            <select
              name="gender"
              id="gender"
              className="w-full p-2 border rounded"
              placeholder={'Gender*'}
              value={formData.gender}
              onChange={handleChange}
            >
              <option value={''}>
                Gender *
              </option>
              <option key={'female'} value={'female'}>
                Female
              </option>
              <option key={'male'} value={'male'}>
                Male
              </option>
              {/*<option key={'other'} value={'other'}>*/}
              {/*  Other*/}
              {/*</option>*/}
            </select>
            {errors.gender && <p className="text-red-500 error-text">{errors.gender}</p>}

            <div style={{marginTop: 8, marginBottom: 0, marginLeft: 4, fontSize: 12, color: '#AAA'}}>Date of Birth</div>
            <DateOfBirthPicker
              onDobChange={(dob) => {
                setFormData({...formData, dob})
                setErrors({...errors, ['dob']: ''})
              }}
              dobValue={formData.dob}/>
            {errors.dob && <p className="text-red-500 error-text">{errors.dob}</p>}
            <select
              name="nationality"
              id="nationality"
              value={formData.nationality}
              placeholder="Nationality*"
              className="w-full p-2 border rounded"
              onChange={handleChange}
            >
              <option value="">Select Nationality</option>
              {nationalities.map(nationality => (
                <option key={nationality} value={nationality}>{nationality}</option>
              ))}
            </select>
            {errors.nationality && <p className="text-red-500 error-text">{errors.nationality}</p>}
            <input
              type="email"
              name="email"
              placeholder="Email*"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.email}
            />
            {errors.email && <p className="text-red-500 error-text">{errors.email}</p>}

            <input
              type="text"
              name="address"
              placeholder="Address*"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.address}
            />
            {errors.address && <p className="text-red-500 error-text">{errors.address}</p>}

            <input
              type="text"
              name="addressLine2"
              placeholder="Address Line 2"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.addressLine2}
            />

            <input
              type="text"
              name="city"
              placeholder="City*"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.city}
            />
            {errors.city && <p className="text-red-500 error-text">{errors.city}</p>}

            <input
              type="text"
              name="state"
              placeholder="State/Region/Province*"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.state}
            />
            {errors.state && <p className="text-red-500 error-text">{errors.state}</p>}

            {/*<input*/}
            {/*  type="text"*/}
            {/*  name="country"*/}
            {/*  placeholder="Country*"*/}
            {/*  className="w-full p-2 border rounded"*/}
            {/*  onChange={handleChange}*/}
            {/*  value={formData.country}*/}
            {/*/>*/}
            <select
              name="country"
              id="country"
              className="w-full p-2 border rounded"
              placeholder={'Country*'}
              value={formData.country}
              onChange={handleChange}
            >
              <option value={''}>
                Country *
              </option>
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
            {errors.country && <p className="text-red-500 error-text">{errors.country}</p>}

            <input
              type="text"
              name="postalZip"
              placeholder="Postal/Zip*"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.postalZip}
            />
            {errors.postalZip && <p className="text-red-500 error-text">{errors.postalZip}</p>}

            <PhoneInput
              placeholder="Phone*"
              name="phone"
              value={formData.phone}
              className="w-full p-2 border rounded"
              onChange={handlePhoneChange}/>
            {/*<input*/}
            {/*  type="tel"*/}
            {/*  name="phone"*/}
            {/*  placeholder="Phone*"*/}
            {/*  className="w-full p-2 border rounded"*/}
            {/*  onChange={handleChange}*/}
            {/*  value={formData.phone}*/}
            {/*/>*/}
            {errors.phone && <p className="text-red-500 error-text">{errors.phone}</p>}

            <input
              type="text"
              name="instagramHandle"
              placeholder="Instagram Handle"
              className="w-full p-2 border rounded"
              onChange={handleChange}
              value={formData.instagramHandle}
            />
            {errors.instagramHandle && <p className="text-red-500 error-text">{errors.instagramHandle}</p>}
            <Checkbox checked={billingNotSame}  label="Billing details are DIFFERENT than passenger details"
                      onChange={() => {
                        setBillingNotSame(!billingNotSame)
                        setFormData({
                          ...formData,
                          billing_firstName: '',
                          billing_lastName: '',
                          billing_address: '',
                          billing_addressLine2: '',
                          billing_country: '',
                          billing_city: '',
                          billing_state: '',
                          billing_postalZip: '',
                        })
                      }}/>
            {billingNotSame
              ? <>
                <h4>Billing Details</h4>
                <input
                  type="text"
                  name="billing_firstName"
                  placeholder="First Name*"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_firstName}
                />
                {errors.billing_firstName && <p className="text-red-500 error-text">{errors.billing_firstName}</p>}

                <input
                  type="text"
                  name="billing_lastName"
                  placeholder="Last Name*"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_lastName}
                />
                {errors.billing_lastName && <p className="text-red-500 error-text">{errors.billing_lastName}</p>}

                <input
                  type="text"
                  name="billing_address"
                  placeholder="Address*"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_address}
                />
                {errors.billing_address && <p className="text-red-500 error-text">{errors.billing_address}</p>}

                <input
                  type="text"
                  name="billing_addressLine2"
                  placeholder="Address Line 2"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_addressLine2}
                />

                <input
                  type="text"
                  name="billing_city"
                  placeholder="City*"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_city}
                />
                {errors.billing_city && <p className="text-red-500 error-text">{errors.billing_city}</p>}

                <input
                  type="text"
                  name="billing_state"
                  placeholder="State/Region/Province*"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_state}
                />
                {errors.billing_state && <p className="text-red-500 error-text">{errors.billing_state}</p>}

                {/*<input*/}
                {/*  type="text"*/}
                {/*  name="billing_country"*/}
                {/*  placeholder="Country*"*/}
                {/*  className="w-full p-2 border rounded"*/}
                {/*  onChange={handleChange}*/}
                {/*  value={formData.billing_country}*/}
                {/*/>*/}
                <select
                  name="billing_country"
                  id="billing_country"
                  className="w-full p-2 border rounded"
                  value={formData.billing_country}
                  onChange={handleChange}
                >
                  <option value={''}>
                    Country *
                  </option>
                  {countries.map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
                </select>
                {errors.billing_country && <p className="text-red-500 error-text">{errors.billing_country}</p>}

                <input
                  type="text"
                  name="billing_postalZip"
                  placeholder="Postal/Zip*"
                  className="w-full p-2 border rounded"
                  onChange={handleChange}
                  value={formData.billing_postalZip}
                />
                {errors.billing_postalZip && <p className="text-red-500 error-text">{errors.billing_postalZip}</p>}
              </>
              : <></>}

            <Button type="submit" className="text-white rounded w-full mt-4" disabled={customerSaving}>Continue to
              Payment</Button>
          </form>
        </>
      ) : (
        <> </>
      )}
    </section>
  )
}
